import { Paperclip } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface AttachmentButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export function AttachmentButton({ onClick, disabled }: AttachmentButtonProps) {
  return (
    <Button
      type="button"
      variant="outline"
      size="icon"
      onClick={onClick}
      disabled={disabled}
      className="h-12 w-12 rounded-full border-border/60 bg-background/70 text-muted-foreground hover:text-foreground hover:bg-background"
      aria-label="Ajouter une pièce jointe"
    >
      <Paperclip className="h-5 w-5" />
    </Button>
  );
}
